export function IsBetweenSixMonthsAndOneYear(startDateStr: string | undefined): boolean {
  const startDate = new Date(startDateStr ? startDateStr : '')
  const sixMonthsLater = new Date(startDate)
  sixMonthsLater.setMonth(startDate.getMonth() + 6)

  const oneYearLater = new Date(startDate)
  oneYearLater.setFullYear(startDate.getFullYear() + 1)

  const today = new Date()

  return today >= sixMonthsLater && today < oneYearLater
}

export function IsOneYearOrMore(startDateStr: string | undefined): boolean {
  const startDate = new Date(startDateStr ? startDateStr : '')
  const oneYearLater = new Date(startDate)
  oneYearLater.setFullYear(startDate.getFullYear() + 1)

  const today = new Date()
  return today >= oneYearLater
}
